var map = {
	"./CAN/MSP_CANADA/MNDBDCND/logo.png": 34157,
	"./CAN/MSP_CANADA/NRDXSLTNS/logo.png": 85401,
	"./CAN/MSP_CANADA/PVDSLTNSNC/logo.png": 44264,
	"./USA/AGENT_BANK/CNTRBNK/logo.png": 19179,
	"./USA/AGENT_BANK/STHSTTBNK/logo.png": 93288,
	"./USA/ATHENA_HEALTH/logo.png": 12536,
	"./USA/KEY_BANK/logo.png": 89402,
	"./USA/MSP_USA/LPPMNTS/logo.png": 96691,
	"./USA/MSP_USA/MNDBD/logo.png": 7166
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65053;